<template>
  <div class="g-desc">
    <img src="../../assets/tongwei/icon1.png" alt="" class="u-icon1">
    <p :class="'m-desc ' + elems.articles[0].summary_font_size">
      {{ this.Trim(elems.articles[0].summary) }}
    </p>

    <!-- <div @click.stop="support($event, elems.articles[0].article_id,elems.articles[0])" class="u-supportBox">
        <img src="../../assets/tongwei/support.png" alt=""  class="u-support">
        <img src="../../assets/tongwei/supportActive.png" alt=""  class="u-supportActive">
        {{elems.articles[0].support_counts}}
    </div> -->

  </div>
</template>

<script>
export default {
  props: {
    elems: Object,
  },
  methods: {
    // support(e, id, array) {

      
    //   if (e.target.className.indexOf('active') == -1) {
    //     this.$axios({
    //       method: 'post',
    //       url: '/tongwei/api/articles/support_article',
    //       data: {
    //         article_id: id
    //       }
    //     }).then(res => {
    //       console.log(e.target)

    //       e.target.classList.add('active')
    //       array.support_counts +=1
    //     })
    //   }

    // }
  }
};
</script>

<style lang="scss" scoped>
.g-desc {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  position: relative;
  // padding-bottom: .3333rem;
}

.u-icon1 {
  width: .293333rem;
  height: .333333rem;
  margin-right: .266667rem;
  margin-top: 0;
}

.m-desc {
  font-size: .32rem;
  color: #666;
  text-align: justify;
  line-height: 1.5;
  text-indent: 2em;
}
</style>